var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoTasks(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 16,
    viewBox: "0 0 30 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7178 0.281291C24.0941 0.656346 24.0941 1.26309 23.7178 1.63815L9.44363 15.7187C9.06732 16.0938 8.44444 16.0938 8.06813 15.7187L0.282238 8.0384C-0.0940795 7.66335 -0.0940795 7.0566 0.282238 6.68155C0.658556 6.30649 1.28143 6.30649 1.65775 6.68155L8.75588 13.6821L10.6245 11.8402L6.77048 8.0384C6.39416 7.66335 6.39416 7.0566 6.77048 6.68155C7.1468 6.30649 7.76967 6.30649 8.14599 6.68155L12 10.482L22.3423 0.281291C22.7186 -0.0937638 23.3414 -0.0937638 23.7178 0.281291ZM29.7215 0.281291C30.0928 0.656346 30.0928 1.26309 29.7215 1.63815L15.6359 15.7187C15.2645 16.0938 14.6499 16.0938 14.2785 15.7187C13.9072 15.3437 13.9072 14.7369 14.2785 14.3619L28.3641 0.281291C28.7355 -0.0937638 29.3501 -0.0937638 29.7215 0.281291Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoTasks);
export default __webpack_public_path__ + "static/media/ico-tasks.93e673a8.svg";
export { ForwardRef as ReactComponent };